<template>
    <div class="otherInfo app-container">
        <div class="app-table-container">
            <dataTable :tableData="tableData" :tableProps="tableProps">
                <div class="other-table-header" slot="header">
                    <h3>{{$t('org.fliqlo')}}<span>{{$t('org.fliqloTip')}}</span></h3>
                </div>
                <!-- <pagination
                layout="prev, pager, next"
                /> -->
            </dataTable>            
            <el-card class="otherInfo-bottom" :body-style="{ padding: '0' }">
                <div slot="header">
                    <h3>{{$t('org.fliqlo')}}<span>{{$t('org.fliqloTip')}}</span></h3>
                </div>
                <div class="otherInfo-bottom-main" v-for="item in uploadInput" :key="item">
                    <span>{{item}}</span>
                    <el-input></el-input>
                    <el-button type="primary" plain>{{$t('commonMsg.preview')}}</el-button>
                </div>
            </el-card>
        </div>
        
    </div>
</template>

<script>
import dataTable from '@/components/dataTable'
import pagination from '@/components/pagination'
export default {
    components: {
        dataTable,
        pagination
    },
    computed: {
        uploadInput() {
            let uploadInput = [this.$t('org.powerOn'), this.$t('org.standby'), this.$t('org.powerOff')]
            return uploadInput
        },
        tableProps() {
            let tableProps = [{
                prop:'channels',
                label: this.$t('org.storeChannel')
            }, {
                prop:'modules',
                label: this.$t('org.storeFrame')
            }, {
                prop:'banner',
                label: this.$t('org.storeBanner')
            }]
            return tableProps
        }
    },
    data() {
        return {
            tableData:[{
                channels:'排行、新书、VIP、分类',
                modules: '投资理财、家庭育儿、新书推荐、畅销推荐',
                banner: '图书大优惠、五一青年'
            }, {
                channels:'排行、新书、VIP、分类',
                modules: '投资理财、家庭育儿、新书推荐、畅销推荐',
                banner: '图书大优惠、五一青年'
            },{
                channels:'排行、新书、VIP、分类',
                modules: '投资理财、家庭育儿、新书推荐、畅销推荐',
                banner: '图书大优惠、五一青年'
            },{
                channels:'排行、新书、VIP、分类',
                modules: '投资理财、家庭育儿、新书推荐、畅销推荐',
                banner: '图书大优惠、五一青年'
            },{
                channels:'排行、新书、VIP、分类',
                modules: '投资理财、家庭育儿、新书推荐、畅销推荐',
                banner: '图书大优惠、五一青年'
            },{
                channels:'排行、新书、VIP、分类',
                modules: '投资理财、家庭育儿、新书推荐、畅销推荐',
                banner: '图书大优惠、五一青年'
            },{
                channels:'排行、新书、VIP、分类',
                modules: '投资理财、家庭育儿、新书推荐、畅销推荐',
                banner: '图书大优惠、五一青年'
            },{
                channels:'排行、新书、VIP、分类',
                modules: '投资理财、家庭育儿、新书推荐、畅销推荐',
                banner: '图书大优惠、五一青年'
            },{
                channels:'排行、新书、VIP、分类',
                modules: '投资理财、家庭育儿、新书推荐、畅销推荐',
                banner: '图书大优惠、五一青年'
            },{
                channels:'排行、新书、VIP、分类',
                modules: '投资理财、家庭育儿、新书推荐、畅销推荐',
                banner: '图书大优惠、五一青年'
            },{
                channels:'排行、新书、VIP、分类',
                modules: '投资理财、家庭育儿、新书推荐、畅销推荐',
                banner: '图书大优惠、五一青年'
            },{
                channels:'排行、新书、VIP、分类',
                modules: '投资理财、家庭育儿、新书推荐、畅销推荐',
                banner: '图书大优惠、五一青年'
            },{
                channels:'排行、新书、VIP、分类',
                modules: '投资理财、家庭育儿、新书推荐、畅销推荐',
                banner: '图书大优惠、五一青年'
            },{
                channels:'排行、新书、VIP、分类',
                modules: '投资理财、家庭育儿、新书推荐、畅销推荐',
                banner: '图书大优惠、五一青年'
            },{
                channels:'排行、新书、VIP、分类',
                modules: '投资理财、家庭育儿、新书推荐、畅销推荐',
                banner: '图书大优惠、五一青年'
            },{
                channels:'排行、新书、VIP、分类',
                modules: '投资理财、家庭育儿、新书推荐、畅销推荐',
                banner: '图书大优惠、五一青年'
            },{
                channels:'排行、新书、VIP、分类',
                modules: '投资理财、家庭育儿、新书推荐、畅销推荐',
                banner: '图书大优惠、五一青年'
            },{
                channels:'排行、新书、VIP、分类',
                modules: '投资理财、家庭育儿、新书推荐、畅销推荐',
                banner: '图书大优惠、五一青年'
            },{
                channels:'排行、新书、VIP、分类',
                modules: '投资理财、家庭育儿、新书推荐、畅销推荐',
                banner: '图书大优惠、五一青年'
            },{
                channels:'排行、新书、VIP、分类',
                modules: '投资理财、家庭育儿、新书推荐、畅销推荐',
                banner: '图书大优惠、五一青年'
            },]
        } 
    },
    mounted() {
    }
}
</script>

<style lang="scss" scoped>

    .otherInfo {
        .app-table-container{
            overflow: hidden;
        }
        .el-input {
            width:200px;
            margin:0 20px;
        }
        .otherInfo-table{
            flex:1;
            overflow: hidden;
        }
        .otherInfo-bottom{
            margin-top:20px;
            .otherInfo-bottom-main{
                padding:10px;
            }
        }
        .other-table-header{
            padding-bottom: 18px;
            margin-bottom: 20px;
            border-bottom: 1px solid #EBEEF5;
            box-sizing: border-box;
        }
    } 
</style>
